import { maxDaysForActiveGoal, maxGoodDaysLeft, minGoodDaysLeft } from 'source/app/presentation/MainPanel/Goals/GoalCards/Helpers/GoalCardsConstants';

export const IsGoalDaysLeftBad = (daysLeft: number) => {
	const daysLeftRounded = Math.floor(daysLeft);

	const isBad =
		(daysLeftRounded >= 0 && daysLeftRounded < minGoodDaysLeft) ||
		(daysLeftRounded > maxGoodDaysLeft &&
			daysLeftRounded < maxDaysForActiveGoal);

	return isBad;
};

export const IsGoalDaysLeftAlmostBad = (daysLeft: number) => {
	const daysLeftRounded = Math.floor(daysLeft);
	const isAlmostBad = daysLeftRounded === minGoodDaysLeft;
	return isAlmostBad;
};
